<app-billing-header></app-billing-header>
<div class="content">
    <h2 class="mat-dialog-title custom-billing-heading">Subscription Plan</h2>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px" class="pricing-container card-container">
        <mat-card *ngFor="let plan of user_subscription_plans; let i = index" class="pricing-card col-md-3">
            <mat-card-content>
                <h2 class="plan-title">{{ plan.name === 'Hobbyist' ? 'Hobbyist' : plan.name}}</h2>
                <h3 class="plan-price">${{ plan.price }}
                    <span class="plan-duration">{{ plan.name === 'tune2 hobbyist' ? 'a month' : 'a year' }}</span>
                </h3>

                <ul class="SelectPlan_ul">
                    <li *ngFor="let feature of subscription_plan_features; let j = index">
                        {{ feature }}
                    </li>
                </ul>

                <!-- Current / Select Plan Button -->
                <button mat-raised-button [color]="get_user_subscription_plan === plan.value ? undefined : 'secondary'"
                    [ngStyle]="get_user_subscription_plan === plan.value 
                                    ? { 'background-color': 'var(--primary-color)', 'color': 'var(--light-color)' } 
                                    : {}" [disabled]="get_user_subscription_plan === plan.value"
                    [ngClass]="get_user_subscription_plan === plan.value ? 'current-plan' : ''"
                    (click)="get_user_subscription_plan !== plan.value && subscribe(plan.name)">
                    {{ get_user_subscription_plan === plan.value ? 'Current Plan' : 'Select Plan' }}
                </button>

                <!-- Cancel Subscription Button -->
                <div *ngIf="get_user_subscription_plan === plan.value">

                    <button *ngIf="!will_cancel_at_end_of_period" mat-raised-button color="warn"
                        (click)="caneclSubscription(plan.name.toLowerCase())">
                        Cancel Subscription
                    </button>

                    <span class="pill" [ngClass]="will_cancel_at_end_of_period ? 'cancel' : 'renew'">
                        {{ will_cancel_at_end_of_period ? 'Cancels on' : 'Renews on' }}
                        {{ subscription_end_date | date:'mediumDate' }}
                    </span>

                </div>


            </mat-card-content>
        </mat-card>
    </div>
</div>